{
    "smartTasks": {
        "generate": {
            "focusApp": {
                "title": "Concéntrese en la aplicación",
                "description": "Asegúrate de estar enfocado en la aplicación donde quieres que aparezca el texto generado. Podrás generar texto sin problemas en esa ubicación al hacer clic en \"Generar\"."
            }
        },
        "rewrite": {
            "focusApp": {
                "title": "Concéntrese en la aplicación",
                "description": "Asegúrate de estar enfocado en la aplicación donde quieres que aparezca el texto reescrito. Podrás generar texto sin problemas en esa ubicación al hacer clic en \"Generar\"."
            }
        }
    },
    "customControls": {
        "tourLabel": "Controles globales y de dispositivos siempre disponibles",
        "rowDescription": "Los controles globales y del dispositivo siempre están disponibles si el micrófono está activado, independientemente de la aplicación que uses. Puedes usar estos controles para interactuar con tu dispositivo sin tener que crear nuevos controles para la aplicación. Incluyen comandos útiles como intercambiar controles o aplicaciones, generar texto, pausar el micrófono y mucho más."
    },
    "profile": {
        "switch": {
            "title": "Cambiar controles de la aplicación",
            "description": "Los controles de tu aplicación pueden cambiar automáticamente según la aplicación que estés utilizando, o puedes modificarlos manualmente aquí en cualquier momento."
        }
    },
    "dictation": {
        "tourLabel": "Dictado",
        "learn": "Aprenda a utilizar el modo de dictado para convertir su voz en texto con manos libres.",
        "welcome": {
            "title": "Dictado",
            "description": "El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."
        },
        "microphone": {
            "title": "Enciende tu micrófono",
            "description": "Primero, activa el micrófono. Haz clic en el interruptor de micrófono en el panel de Cephable."
        },
        "activate": {
            "title": "Iniciar el modo de dictado",
            "description": "La voz se inicia en modo comando. Para iniciar el dictado, diga \"Iniciar dictado\" o haga clic en el botón Dictado. Activemos el modo de dictado."
        },
        "focus": {
            "title": "Centrarse en un campo de texto o documento",
            "description": "El dictado funciona mejor cuando te centras en un campo de texto o documento. Haz clic en el campo de texto o documento donde quieras dictar."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puedes empezar a hablar. Todo lo que digas se escribirá en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \"Hola, esta es una prueba del modo de dictado\"."
        },
        "pauseResume": {
            "title": "Pausa del dictado",
            "description": "¿Necesitas un descanso sin desactivar el dictado? Simplemente di \"Pausar dictado\". Puedes reanudarlo en cualquier momento con \"Iniciar dictado\". Puedes personalizarlo aún más con los controles globales y del dispositivo siempre activos."
        },
        "stop": {
            "title": "Detener el dictado",
            "description": "¿Necesitas volver a los controles de tu aplicación? Simplemente di \"Detener dictado\". Esto detendrá el modo de dictado y te permitirá volver al modo comando. Puedes reanudarlo en cualquier momento con \"Iniciar dictado\"."
        },
        "complete": {
            "description": "¡Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. Úsalo para escribir correos electrónicos, documentos o cualquier otra cosa que necesites escribir en voz alta."
        }
    },
    "microphone": {
        "tourLabel": "Controles de voz",
        "learn": "Aprenda cómo puede usar su voz para controlar cualquier aplicación y usar el dictado para escribir lo que dice.",
        "rowDescription": "Cuando el micrófono esté apagado, no escucharemos tus comandos de voz, pero si lo enciendes, podrás usar comandos globales para pausar, iniciar y más. Vamos a encenderlo.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Spotify» o «Abrir Word»."
        },
        "finishedCommands": {
            "title": "¡Excelente! Has aprendido lo básico de los controles de voz.",
            "description": "Siempre puedes volver a visitar el recorrido desde la página de soporte. El siguiente paso es aprender sobre Dictado. Puedes comenzar el recorrido desde la página de soporte."
        }
    },
    "tour": {
        "startTour": "Iniciar Tour",
        "finishTour": "Finalizar el recorrido",
        "statusDialog": "Por favor consulte el panel para obtener más información.",
        "step": "Paso {{paso}} de {{total}}",
        "skipTour": "Saltar el recorrido"
    },
    "onboarding": {
        "overview": "Descripción general",
        "learn": "Conozca las características de Cephable y cómo usarlas.",
        "start": "Parece que apenas estás empezando. Aquí tienes algunas áreas que te ayudarán en el proceso.",
        "dashboard": {
            "title": "Espacio de trabajo cefalable",
            "description": "El espacio de trabajo de Cephable es tu centro de control para gestionar tu dispositivo, los controles de la aplicación y la configuración. Desde aquí, puedes personalizar tu experiencia, ver los comandos activos y acceder a todas las funciones de Cephable."
        },
        "step1": {
            "title": "Bienvenido a Cephable",
            "description": "Cephable es tu IA personal: diseñada para acciones rápidas, comandos de voz, generación de contenido y automatización inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo."
        },
        "finish": {
            "continueToApp": "Continuar al panel de Cephable",
            "keepExploring": "Sigue explorando"
        },
        "useCaseSlider": {
            "context": "Me gustaría usar",
            "control": "Para controlar"
        }
    },
    "support": {
        "description": "Puede visitar nuestro centro de soporte para obtener más información sobre cómo usar Cephable, incluidos más recorridos, guías paso a paso, tutoriales y videos.",
        "title": "Apoyo"
    },
    "editingVideos": {
        "tourLabel": "Concéntrese en la historia, no en los tediosos clics de la edición de video",
        "learn": "Aprende a usar los controles de voz y el dictado para editar vídeos más rápido y elimina la carga cognitiva de recordar qué botones pulsar durante la edición.",
        "tryOpen": {
            "title": "Prueba a decir `Abrir CapCut` o `Abrir iMovie`."
        },
        "complete": {
            "description": "Ahora ya sabes cómo usar comandos de voz y acciones rápidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus aplicaciones de edición de vídeo favoritas. Explora más comandos o personaliza tus propias acciones rápidas para un control de vídeo aún más fluido."
        }
    },
    "congrats": "¡Felicitaciones!",
    "fpsGamePlay": {
        "tourLabel": "Juega juegos FPS con controles de voz",
        "learn": "Aprende a usar controles de voz y acciones rápidas para jugar juegos FPS.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Valorant» o «Abrir Battlefield»."
        },
        "complete": {
            "description": "Ya sabes cómo usar comandos de voz y acciones rápidas para moverte, detenerte y controlar a tu personaje en juegos FPS. Explora más comandos o personaliza tus propias acciones rápidas para disfrutar de una experiencia de juego aún más fluida y rápida."
        }
    },
    "redo": "Rehacer la incorporación",
    "title": "Conoce a Cephable",
    "description": "Conozca Cephable, su asistente personal de IA y comparta su interés en casos de uso personalizados.",
    "panel": {
        "description": "Este es el panel, el centro de control principal. Siempre está visible y te permite controlar tus aplicaciones con la voz, entre otras funciones. Empecemos por el micrófono."
    },
    "controlExpanded": {
        "tourLabel": "Control",
        "description": "Los controles de la aplicación son conjuntos de controles configurables que puedes usar en la aplicación que desees. Esta sección te muestra todos los controles disponibles que puedes usar mediante comandos de voz, toques, escritura y más."
    },
    "submit": {
        "title": "Entregar",
        "description": "El contenido se mostrará donde se encuentre el cursor."
    },
    "tryOpen": {
        "description": "`Open` es un comando global que abrirá la aplicación que especifiques y le asignará el foco. Si tienes habilitada la opción de cambio automático de controles, también cambiará a los controles de la aplicación que mejor se adapten a la que estés utilizando."
    },
    "modeSelector": {
        "title": "Seleccionar modo",
        "description": "Si está disponible, puedes seleccionar el modo en el que operaré. Usa Control para la aplicación a través de la cual quieras enviar comandos, Crear para contenido de texto generativo como resumir, reescribir o traducir. Selecciona Automatizar para flujos de escritorio o entre aplicaciones."
    },
    "contextSelector": {
        "title": "Seleccionar contexto",
        "description": "Si está disponible, puede seleccionar el contexto en el que trabajaré. Por ejemplo, puedo usar el contenido de su portapapeles o el texto resaltado, y también puede adjuntar archivos o carpetas con los que desee que trabaje."
    },
    "panelInput": {
        "title": "¿Qué quieres que haga?",
        "description": "Puedes darme órdenes, escribirlas o dictarme lo que quieres que haga."
    },
    "figma": {
        "tourLabel": "Comandos de voz para Figma y Canva",
        "learn": "Aprende a usar los controles de voz, el ratón por voz, el dictado y la generación de contenido mediante IA de Controls para mejorar tu flujo de trabajo de diseño.",
        "complete": {
            "description": "Ahora ya sabes cómo controlar y crear diseños para optimizar tu flujo de trabajo. Explora más comandos para un control de diseño aún más fluido."
        },
        "tryOpen": {
            "title": "Prueba a decir `Abrir Figma` o `Abrir Canva`."
        }
    },
    "voiceMouse": {
        "title": "Ratón de voz",
        "description": "Para hacer clic en los botones por su nombre, puede usar Voice Mouse. Para ello, diga «toque guardar» o «vaya a configuración»."
    },
    "documentSummary": {
        "tourLabel": "Borradores de resúmenes de equipos a partir de informes confidenciales",
        "learn": "Automatice la lectura de los informes departamentales, identifique a las personas adecuadas para informar y redacte un correo electrónico, todo ello desde su dispositivo, para que sus datos confidenciales permanezcan privados.",
        "congrats": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para leer documentos confidenciales y redactar un correo electrónico de resumen para tu equipo, todo ello sin que tus datos salgan de tu dispositivo."
        }
    },
    "extensions": {
        "tourLabel": "Extensiones",
        "rowDescription": "Amplía las funciones de Cephable con más opciones para controlar tu dispositivo, como controles de cámara para el movimiento de la cara y la cabeza, o compatibilidad con mandos. Activa las que necesites aquí."
    },
    "developerBuildTests": {
        "tourLabel": "Automatice las compilaciones y las pruebas con flujos de trabajo de IA.",
        "learn": "Cephable puede ejecutar tareas de terminal de varios pasos, como compilar tu proyecto y ejecutar sus pruebas, completamente en el dispositivo, en segundo plano, mientras sigues trabajando.",
        "complete": {
            "description": "Ahora ya sabes cómo ejecutar flujos de trabajo de IA en dispositivos para tareas de compilación y prueba de varios pasos, responder a solicitudes de permisos y seguir iterando sobre los resultados. Prueba a automatizar otra tarea de desarrollo repetitiva."
        }
    },
    "classroomStudyTools": {
        "tourLabel": "Convierte tus apuntes de clase y artículos en herramientas de estudio y materiales didácticos.",
        "learn": "Cephable ofrece a profesores y alumnos funciones de dictado, herramientas de creación en el dispositivo y automatización, todo ello integrado en las aplicaciones que ya utilizas, manteniendo la privacidad de toda la información en tu dispositivo.",
        "complete": {
            "description": "Ahora ya sabes cómo dictar directamente en tus documentos, generar nuevos materiales de estudio a partir de tus apuntes y usar Automate para crear tareas completas en segundo plano, todo ello desde tu dispositivo."
        }
    },
    "engineeringFlows": {
        "tourLabel": "Controles por voz y automatización con IA para desarrolladores",
        "learn": "Aprende a agilizar tu flujo de trabajo de ingeniería con comandos de desarrollo controlados por voz, reescritura de código mediante IA utilizando tu propio código como contexto y flujos de trabajo de IA en segundo plano, todo ello ejecutándose en el dispositivo.",
        "tryOpen": {
            "title": "Intenta decir `Abrir Visual Studio Code`."
        },
        "complete": {
            "description": "Ahora ya sabes cómo usar comandos de desarrollo controlados por voz, la función de reescritura de IA con tu propio código como contexto y flujos de trabajo de IA en segundo plano para acelerar tu proceso de ingeniería."
        }
    },
    "meetingNotesToFiles": {
        "tourLabel": "Convierta las notas de las reuniones en archivos útiles para la toma de decisiones.",
        "learn": "Cephable puede dividir las notas de tus reuniones en archivos más pequeños y prácticos con los que puedes trabajar a tu propio ritmo, todo ello directamente en tu dispositivo.",
        "complete": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para dividir las notas de las reuniones en archivos más pequeños y prácticos, y retomar la conversación en cualquier momento desde el historial de IA."
        }
    },
    "notesToPresentation": {
        "tourLabel": "Resume notas confidenciales y crea una presentación, todo desde tu dispositivo.",
        "learn": "Cephable puede resumir tus informes y notas confidenciales, y luego usar flujos de trabajo de IA para hacerlo en toda una carpeta de archivos, e incluso crear una presentación a partir de los resultados. Todo se ejecuta en tu dispositivo.",
        "complete": {
            "description": "Ahora ya sabes cómo resumir documentos confidenciales, resumir por lotes una carpeta completa con flujos de trabajo de IA y convertir los resultados en una presentación, todo ello sin que tus datos salgan de tu dispositivo."
        }
    },
    "organizeDownloads": {
        "tourLabel": "Organiza tus archivos, limpia y encuentra lo que perdiste con flujos de trabajo de IA.",
        "learn": "Automate puede gestionar tareas de administración de archivos en varios pasos (copiar, eliminar y buscar archivos) directamente desde una simple solicitud.",
        "complete": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para organizar archivos, limpiarlos de forma segura con comprobaciones de permisos y encontrar archivos cuya ubicación no recuerdas."
        }
    },
    "outlookEmailProductivity": {
        "tourLabel": "Agiliza el correo electrónico en Outlook con dictado, acciones rápidas e inteligencia artificial.",
        "learn": "Cephable Plus y Professional incluyen herramientas inteligentes de dictado y creación para generar y editar contenido; úselas directamente en Outlook para responder y redactar correos electrónicos más rápidamente.",
        "complete": {
            "description": "Ahora ya sabes cómo responder a correos electrónicos mediante dictado, usar tus propias acciones de Escritura rápida y utilizar las funciones Resumir y Generar para redactar y perfeccionar el contenido de los correos electrónicos, todo ello desde tu dispositivo."
        }
    },
    "customizingGameControls": {
        "tourLabel": "Juega a juegos de rol con control por voz.",
        "learn": "Aprende a usar los controles de voz y las acciones rápidas para jugar a juegos de rol.",
        "tryOpen": {
            "title": "Intenta decir `Abre Minecraft`"
        },
        "complete": {
            "description": "Ahora ya sabes cómo usar comandos de voz y acciones rápidas para mover, detener y controlar a tu personaje en juegos de rol. Explora más comandos o personaliza tus propias acciones rápidas para una experiencia de juego aún más fluida y rápida."
        }
    },
    "voiceToTextSocialMedia": {
        "tourLabel": "Conversión de voz a texto para LinkedIn, Slack y Discord.",
        "learn": "Utiliza el Dictado Inteligente para redactar un mensaje de forma natural y, a continuación, la función Reescribir para ajustar el tono; funciona de la misma manera en LinkedIn, Slack, Discord y otras plataformas.",
        "complete": {
            "description": "Ahora ya sabes cómo redactar una publicación y perfeccionarla con Rewrite, en LinkedIn, Slack, Discord y más."
        }
    },
    "aiDocumentTranslation": {
        "tourLabel": "Traduce documentos a cualquier idioma, directamente en tu dispositivo.",
        "learn": "Cephable puede traducir un documento a un idioma a la vez, o utilizar flujos de trabajo de IA para traducirlo a varios idiomas simultáneamente, todo ello ejecutándose localmente.",
        "complete": {
            "description": "Ahora ya sabes cómo traducir un documento a un solo idioma mediante dictado, o a varios idiomas a la vez con flujos de trabajo de IA, todo ello desde tu dispositivo."
        }
    },
    "excelAiAutomation": {
        "tourLabel": "Analice hojas de cálculo con IA privada en su dispositivo.",
        "learn": "Cephable puede leer tus archivos de Excel, responder preguntas sobre los números e ir profundizando aún más, todo ello sin que tus datos salgan de tu dispositivo.",
        "complete": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para cuestionar tus hojas de cálculo, profundizar en los datos con seguimientos y guardar un resumen, todo ello ejecutándose en tu dispositivo."
        }
    },
    "handsFreeComputerControl": {
        "tourLabel": "Controla tu ordenador con voz y cámara.",
        "learn": "Cephable te permite controlar tu ordenador sin usar las manos mediante comandos de voz, Voice Mouse y controles faciales y de cabeza basados en la cámara.",
        "tryOpenWord": {
            "title": "Intenta decir \"Palabra abierta\""
        },
        "openExtensions": {
            "title": "Abre la pestaña Extensiones",
            "description": "Para activar los controles de la cámara, abra la pestaña Extensiones en la ventana principal."
        },
        "turnOnCamera": {
            "title": "Activar los controles de la cámara",
            "description": "Activa la cámara. Aparecerá un icono de cámara junto al icono del micrófono y una nueva sección de Cámara en Ajustes."
        },
        "cameraInPanel": {
            "title": "Controles de la cámara en su panel",
            "description": "Ahora que los Controles de la cámara están activados, el interruptor de la cámara también aparece en tu panel de Cephable; Cephable lo activa automáticamente desde aquí."
        },
        "openCameraSettings": {
            "title": "Abrir la configuración de la cámara",
            "description": "Abre la configuración de la cámara para ajustar con precisión cómo funcionan los controles de cabeza y rostro."
        },
        "chooseHeadMouseMode": {
            "title": "Seleccione un modo de control con el ratón",
            "description": "Elige cómo el movimiento de la cabeza controla el ratón: Deslizamiento constante, Aumento de velocidad o Deslizamiento dinámico."
        },
        "complete": {
            "description": "Ahora ya sabes cómo controlar tu ordenador con la voz, el ratón por voz y los comandos de la cámara (cabeza y rostro). Explora la configuración de la cámara para personalizar los controles a tu gusto."
        }
    },
    "handsFreeTypingDocumentCreation": {
        "tourLabel": "Crea y edita documentos sin usar las manos.",
        "learn": "Utilice las funciones Generar, Reescribir y los controles de voz de forma conjunta para crear y editar un documento, como una factura, prácticamente sin usar las manos.",
        "complete": {
            "description": "Ahora ya sabes cómo generar, reescribir y editar un documento prácticamente sin usar las manos, mediante las funciones Generar, Reescribir y los comandos de voz."
        }
    },
    "webResearchCreateHtml": {
        "tourLabel": "Investiga en la web y crea un sitio web a partir de ella: todo desde tu dispositivo.",
        "learn": "Cephable puede explorar y analizar los sitios web de la competencia y, a continuación, utilizar la información que encuentre para generar un nuevo sitio HTML para usted, todo ello en su dispositivo, de modo que su investigación permanezca privada.",
        "complete": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para investigar los sitios web de la competencia y generar un nuevo sitio HTML a partir de los resultados, todo ello sin que tus datos salgan de tu dispositivo."
        }
    },
    "webResearchSummarize": {
        "tourLabel": "Normativa de investigación y resumen de los resultados: todo en el dispositivo.",
        "learn": "Cephable puede navegar por la web para investigar cambios como nuevas leyes de protección de datos y, a continuación, resumir los hallazgos en información útil para que tu equipo pueda actuar en consecuencia; todo ello directamente en el dispositivo, de modo que tu investigación se mantiene privada.",
        "complete": {
            "description": "Ahora ya sabes cómo usar los flujos de trabajo de IA para investigar los cambios normativos, profundizar en la implementación y redactar los resultados en un correo electrónico que tu equipo pueda revisar, todo ello sin que tus datos salgan de tu dispositivo."
        }
    },
    "stopListening": {
        "title": "Intenta decir \"Deja de escuchar\".",
        "description": "Esto pausa el micrófono sin apagarlo por completo. Di «Empezar a escuchar» de nuevo cuando estés listo."
    }
}
